<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div
    class="modal create-geofence-from-polygon-modal"
    :class="className">
    <div
      class="modal-dialog"
      role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <span v-if="isFrom3dBuilding">{{ capitalize($t('messages.geofenceCreationFromBuilding')) }}</span>
            <span v-else>{{ capitalize($t('messages.geofenceCreationFromPolygon')) }}</span>
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="cancel">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div
            v-if="polygon !== null"
            class="static-map">
            <img
              :src="polygonStaticImageUrl"
              alt="" />
          </div>

          <div class="form-container">
            <selectable-tiles
              v-if="actions.length > 1"
              :items="actions"
              :selected-items="[selectedAction]"
              :should-display-labels="true"
              :should-display-icons="true"
              label-property-name="name"
              icon-property-name="icon"
              :is-multiselect="false"
              :allow-empty="true"
              :is-tile-content-layout-vertical="false"
              :tile-width="`${Math.round(100 / actions.length) - 2}%`"
              @selection-changed="onActionSelected" />

            <template v-if="selectedAction != null">
              <div v-if="selectedAction.id === 'new'">
                <p v-show="candidatePlaces != null && candidatePlaces.length > 0 && isLikelyToBeGeofencingAPlace">
                  {{ $t('messages.selectPlaceFromListOrSpecifyCustomNameAndDescription') }}
                </p>
                <ul class="items-list">
                  <li
                    v-for="place in candidatePlaces"
                    v-show="isLikelyToBeGeofencingAPlace"
                    :key="isNotChina ? place.id : place.uid">
                    <label class="item">
                      <input
                        v-model="selectedPlaceCandidate"
                        type="radio"
                        name="placeCandidate"
                        :value="place.name" />
                      <span>
                        <strong>{{ isNotChina ? place.name : place.title }}</strong
                        ><br />
                        <span class="small">{{ isNotChina ? place.vicinity : place.address }}</span>
                      </span>
                    </label>
                  </li>
                  <li>
                    <label class="item dd-flex flex-column">
                      <div
                        v-show="candidatePlaces != null && candidatePlaces.length > 0 && isLikelyToBeGeofencingAPlace">
                        <input
                          v-model="selectedPlaceCandidate"
                          type="radio"
                          name="placeCandidate"
                          value="custom" />
                        <strong>{{ capitalize($t('messages.custom')) }}</strong
                        ><br />
                      </div>
                      <form class="form-horizontal">
                        <div class="container-fluid">
                          <div>
                            <div class="form-group row">
                              <label class="col-sm-3 control-label">{{ capitalize($t('names.name', { n: 1 })) }}</label>
                              <input
                                v-model="newGeofenceName"
                                type="text"
                                class="form-control col-sm-8" />
                            </div>
                            <div class="form-group row">
                              <label class="col-sm-3 control-label">{{
                                capitalize($t('names.description', { n: 1 }))
                              }}</label>
                              <textarea
                                v-model="newGeofenceDescription"
                                class="form-control col-sm-8"
                                rows="3" />
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="candidatePlaces != null && candidatePlaces.length === 0"
                          class="form-group row mt-3">
                          <div class="offset-sm-3" />
                          <div class="col-sm-8">
                            <div class="alert alert-info big">
                              <span v-if="isFrom3dBuilding">{{
                                capitalize($t('messages.noPlacesWereFoundWithinTheBuilding'))
                              }}</span>
                              <span v-else-if="isLikelyToBeGeofencingAPlace || candidatePlaces.length === 0">{{
                                capitalize($t('messages.noPlacesWereFoundWithinThePolygon'))
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </form>
                    </label>
                  </li>
                </ul>
              </div>
              <div v-if="selectedAction.id === 'add'">
                <div>
                  <ul
                    class="items-list"
                    :class="{ 'no-padding': nearPolygonGeofencesThatAreNotPointsSortedByDistance.length === 1 }">
                    <li
                      v-for="match in nearPolygonGeofencesThatAreNotPointsSortedByDistance"
                      :key="match.geofence.id">
                      <label class="item">
                        <input
                          v-show="nearPolygonGeofencesThatAreNotPointsSortedByDistance.length > 1"
                          v-model="selectedNearbyGeofenceID"
                          type="radio"
                          :checked="nearPolygonGeofencesThatAreNotPointsSortedByDistance.length === 1"
                          name="nearbyGeofence"
                          :value="match.geofence.id" />
                        <div
                          class="well dark"
                          style="flex-grow: 1">
                          <strong>{{ match.geofence.name }}</strong> ({{ match.distanceInMeters }}m)<br />
                          <span class="small">{{ match.geofence.description }}</span>
                        </div>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
              <div v-if="selectedAction.id === 'link'">
                <div>
                  <ul
                    class="items-list"
                    :class="{ 'no-padding': nearPolygonGeofences.length === 1 }">
                    <template v-if="inPolygonGeofences != null && inPolygonGeofences.length > 0">
                      <li
                        v-for="match in inPolygonGeofences"
                        :key="match.id">
                        <label class="item">
                          <input
                            v-show="inPolygonGeofences.length > 1"
                            v-model="selectedNearbyGeofenceID"
                            type="radio"
                            :checked="inPolygonGeofences.length === 1"
                            name="nearbyGeofence"
                            :value="match.id" />
                          <div
                            class="well dark"
                            style="flex-grow: 1">
                            <strong>{{ match.name }}</strong
                            ><br />
                            <span class="small">{{ match.description }}</span>
                          </div>
                        </label>
                      </li>
                    </template>
                    <template v-else>
                      <li
                        v-for="match in nearPolygonGeofencesSortedByDistance"
                        :key="match">
                        <label class="item">
                          <input
                            v-show="nearPolygonGeofences.length > 1"
                            v-model="selectedNearbyGeofenceID"
                            type="radio"
                            :checked="nearPolygonGeofences.length === 1"
                            name="nearbyGeofence"
                            :value="match.geofence.id" />
                          <div
                            class="well dark"
                            style="flex-grow: 1">
                            <strong>{{ match.geofence.name }}</strong> ({{ match.distanceInMeters }}m)<br />
                            <span class="small">{{ match.geofence.description }}</span>
                          </div>
                        </label>
                      </li>
                    </template>
                  </ul>
                </div>
              </div>
              <div
                v-if="validationError"
                class="form-group row">
                <div class="offset-sm-3" />
                <div class="col-sm-8">
                  <div class="alert alert-danger big">
                    <span>{{ validationError }}</span>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="modal-footer">
          <button
            id="create_geofence_from_polygon_btn"
            type="button"
            class="btn btn-primary"
            @click="confirm">
            {{ $t('actions.ok') }}
          </button>
          <button
            type="button"
            class="btn btn-default"
            data-dismiss="modal"
            @click="cancel">
            {{ $t('actions.cancel') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import { DateTime } from 'luxon';
  import { capitalize, markRaw } from 'vue';

  import { SelectableTiles } from '@/common/components/controls';
  import { IconColoredAdd, IconColoredLink, IconColoredNew } from '@/common/icons/colored';
  import { BaiduMapsApiKey, getDistanceFromLatLonInKm, GoogleMapsApiKey } from '@/globals';
  import i18n from '@/vueI18n';

  export default {
    components: {
      SelectableTiles,
    },
    props: {
      isVisible: {
        type: Boolean,
        default: false,
      },
      polygon: {
        type: Object,
      },
      pointGeofences: {
        type: Array,
      },
      inPolygonGeofences: {
        type: Array,
      },
      isNotChina: {
        type: Boolean,
        default: true,
      },
      nearPolygonGeofences: {
        type: Array,
      },
      isFrom3dBuilding: {
        type: Boolean,
        default: false,
      },
      placesNearByNewPolygon: {
        type: Array,
      },
    },
    data() {
      return {
        candidatePlaces: [],
        circleRadiusDistance: 25,
        circleRadiusDistanceUnit: 'm',
        newGeofenceName: null,
        newGeofenceDescription: null,
        mode: 'new',
        selectedAction: null,
        selectedGeofenceID: null,
        selectedNearbyGeofenceID: null,
        selectedPlaceCandidate: 'custom',
        stage: 0,
        validationError: null,
      };
    },
    computed: {
      actions() {
        const actions = [];
        if (this.inPolygonGeofences.length > 0) {
          actions.push({
            id: 'link',
            name: capitalize(i18n.global.t('actions.linkPolygonToExistingGeofence')),
            icon: markRaw(IconColoredLink),
          });
        } else {
          actions.push({
            id: 'new',
            name: capitalize(i18n.global.t('actions.newGeofenceFromPolygon')),
            icon: markRaw(IconColoredNew),
          });
          if (this.nearPolygonGeofences.length > 0) {
            actions.push({
              id: 'link',
              name: capitalize(i18n.global.t('actions.linkPolygonToExistingGeofence')),
              icon: markRaw(IconColoredLink),
            });
            if (this.nearPolygonGeofences.filter((x) => !x.geofence.isPoint).length > 0) {
              actions.push({
                id: 'add',
                name: capitalize(i18n.global.t('actions.addPolygonToExistingGeofence')),
                icon: markRaw(IconColoredAdd),
              });
            }
          }
        }
        return actions;
      },
      className() {
        if (this.isVisible) {
          return 'visible';
        }
        return 'fade';
      },
      inPolygonGeofenceStaticMapUrl() {
        const geofence = this.inPolygonGeofences[0];
        return this.isNotChina
          ? this.getPolygonGoogleStaticImageUrl(geofence)
          : this.getPolygonBaiduStaticImageUrl(geofence);
      },
      nearPolygonGeofenceStaticMapUrl() {
        const { geofence } = this.nearPolygonGeofences[0];
        return this.isNotChina
          ? this.getPolygonGoogleStaticImageUrl(geofence)
          : this.getPolygonBaiduStaticImageUrl(geofence);
      },
      polygonStaticImageUrl() {
        return this.isNotChina ? this.getPolygonGoogleStaticImageUrl() : this.getPolygonBaiduStaticImageUrl();
      },
      polygonLatLngBounds() {
        const latLngBounds = new window.google.maps.LatLngBounds();
        let coordinates = this.polygon.geometry.coordinates[0][0];
        while (coordinates.length === 1) {
          [coordinates] = coordinates;
        }
        coordinates.forEach((x) => latLngBounds.extend(new window.google.maps.LatLng(x[1], x[0])));
        return latLngBounds;
      },
      nearPolygonGeofencesSortedByDistance() {
        return [...this.nearPolygonGeofences].sort((a, b) => a.distanceInMeters > b.distanceInMeters);
      },
      nearPolygonGeofencesThatAreNotPointsSortedByDistance() {
        return this.nearPolygonGeofences
          .filter((x) => !x.geofence.isPoint)
          .sort((a, b) => a.distanceInMeters > b.distanceInMeters);
      },
      isLikelyToBeGeofencingAPlace() {
        if (this.polygon == null) {
          return true;
        }
        const minLat = Math.min(...this.polygon.geometry.coordinates[0].map((x) => x[1]), 90);
        const maxLat = Math.max(...this.polygon.geometry.coordinates[0].map((x) => x[1]), -90);
        const minLng = Math.min(...this.polygon.geometry.coordinates[0].map((x) => x[0]), 180);
        const maxLng = Math.max(...this.polygon.geometry.coordinates[0].map((x) => x[0]), -180);

        const distance = getDistanceFromLatLonInKm(minLat, minLng, maxLat, maxLng);
        return distance < 0.2;
      },
    },
    watch: {
      inPolygonGeofences() {
        this.setDefaultAction();
      },
      nearPolygonGeofences(val) {
        if (val != null && val.length > 0) {
          this.selectedNearbyGeofenceID = val[0].geofence.id;
        } else {
          this.selectedNearbyGeofenceID = null;
        }
      },
      isVisible(val) {
        if (val) {
          this.resetData();
          this.queryPlacesInPolygon();
          this.setDefaultAction();
        }
      },
      actions() {
        this.setDefaultAction();
      },
    },
    mounted() {
      if (this.nearPolygonGeofences != null && this.nearPolygonGeofences.length === 1) {
        this.selectedNearbyGeofenceID = this.nearPolygonGeofences[0].geofence.id;
      }
      this.selectedAction = this.actions[this.actions.length - 1];
    },
    methods: {
      capitalize(x) {
        return capitalize(x);
      },
      validate() {
        switch (this.selectedAction.id) {
          case 'new':
            if (this.selectedPlaceCandidate === null && this.candidatePlaces.length > 0) {
              this.validationError = i18n.global.t('messages.pleaseSelectAnExistingPlaceOrSpecifyYourOwn');
              return false;
            }
            if (
              this.selectedPlaceCandidate === 'custom' &&
              (this.newGeofenceName === null ||
                this.newGeofenceDescription === null ||
                this.newGeofenceName.trim() === '' ||
                this.newGeofenceDescription.trim() === '')
            ) {
              this.validationError = i18n.global.t('messages.customGeofenceNameAndDescriptionCannotBeEmpty');
              return false;
            }
            break;
          case 'add':
          case 'link':
            if (
              this.selectedNearbyGeofenceID == null &&
              (this.inPolygonGeofences == null || this.inPolygonGeofences.length === 0)
            ) {
              this.validationError = i18n.global.t('messages.pleaseSelectNearbyGeofence');
              return false;
            }
            break;
          default:
            break;
        }
        return true;
      },
      confirm() {
        if (!this.validate()) {
          return;
        }

        let geofence = null;
        let customGeofenceID = null;
        let customGeofenceName = null;
        let customGeofenceDescription = null;
        let placeCandidate = null;

        switch (this.selectedAction.id) {
          case 'new':
            if (this.selectedPlaceCandidate != null && this.selectedPlaceCandidate !== 'custom') {
              if (this.isNotChina) {
                placeCandidate = this.candidatePlaces.filter((x) => x.name === this.selectedPlaceCandidate)[0];
              } else {
                placeCandidate = this.candidatePlaces.filter((x) => x.title === this.selectedPlaceCandidate)[0];
              }
            } else {
              customGeofenceID = DateTime.local().toSeconds();
              customGeofenceName = this.newGeofenceName;
              customGeofenceDescription = this.newGeofenceDescription;
            }
            break;
          case 'link':
          case 'add':
            geofence =
              this.inPolygonGeofences != null && this.inPolygonGeofences.length > 0
                ? this.inPolygonGeofences[0]
                : this.nearPolygonGeofences.filter((x) => x.geofence.id === this.selectedNearbyGeofenceID)[0].geofence;
            break;
          default:
            break;
        }
        this.$emit('confirmed', {
          polygon: this.polygon,
          geofence: this.selectedAction.id !== 'new' ? geofence : null,
          mode: this.selectedAction.id,
          placeCandidate,
          customGeofenceID,
          customGeofenceName,
          customGeofenceDescription,
        });
      },
      cancel() {
        this.$emit('cancelled');
      },
      no() {
        if (this.stage === 0) {
          if (this.nearPolygonGeofences.length > 0) {
            this.stage += 1;
          } else {
            this.stage += 2;
          }
        } else {
          this.stage += 1;
        }
      },
      resetData() {
        [this.selectedAction] = this.actions;
        this.selectedPlaceCandidate = 'custom';
        this.selectedGeofenceID = null;
        this.selectedNearbyGeofenceID =
          this.nearPolygonGeofences != null && this.nearPolygonGeofences.length > 0
            ? this.nearPolygonGeofences[0].geofence.id
            : null;
        this.newGeofenceName = null;
        this.newGeofenceDescription = null;
        this.validationError = null;

        if (this.stage === 2 && this.polygon !== null) {
          this.queryPlacesInPolygon();
        }
      },
      queryPlacesInPolygon() {
        if (window.google === undefined) {
          return;
        }
        if (this.isNotChina) {
          this.candidatePlaces = [];
          const service = new window.google.maps.places.PlacesService(window.document.createElement('div'));
          const bounds = this.polygonLatLngBounds;
          service.nearbySearch(
            {
              bounds,
            },
            (places) => {
              if (places.length > 0) {
                this.candidatePlaces = places.filter(
                  (x) => x.types.filter((y) => y.indexOf('establishment') > -1).length > 0,
                );
              }
            },
          );
        } else {
          this.candidatePlaces = this.placesNearByNewPolygon;
        }
      },
      getPolygonGoogleStaticImageUrl(geofence = null) {
        const size = { width: 640, height: Math.round(window.innerHeight / 5) };
        let markers = '';
        if (geofence !== null) {
          markers = `&markers=color:red%7C${geofence.lat},${geofence.lng}`;
        }
        let coordinates = this.polygon.geometry.coordinates[0];
        while (coordinates.length === 1) {
          [coordinates] = coordinates;
        }
        const path = `fillcolor:0xFF008333%7Ccolor:0xFF0083%7Cweight:3%7C${coordinates
          .map((x) => `${x[1]},${x[0]}`)
          .join('%7C')}`;
        return `https://maps.googleapis.com/maps/api/staticmap?path=${path}${markers}&scale=2&size=${size.width}x${size.height}&maptype=satellite&key=${GoogleMapsApiKey}`;
      },
      getPolygonBaiduStaticImageUrl(geofence = null) {
        const size = { width: 510, height: Math.round(window.innerHeight / 5) };
        let markers = '';
        if (geofence !== null) {
          markers = `&markers=color:red%7C${geofence.lat},${geofence.lng}`;
        }
        let coordinates = this.polygon.coordinates[0][0];
        while (coordinates.length === 1) {
          [coordinates] = coordinates;
        }
        const { bounds } = this.polygon;
        const path = `${coordinates.map((x) => `${x[0]},${x[1]}`).join(';')}`;
        const pathStyle = '0xFF0083,3,1';
        return `https://api.map.baidu.com/staticimage/v2?paths=${path}&scale=2&markers=${markers}&height=${size.height}&width=${size.width}&dpiType=ph&ak=${BaiduMapsApiKey}&pathStyles=${pathStyle}&bbox=${(bounds.Je, bounds.Ne)};${(bounds.Zd, bounds.Xd)}`;
      },
      onActionSelected(action) {
        [this.selectedAction] = action;
        if (action.id === 'new') {
          this.queryPlacesInPolygon();
        }
      },
      setDefaultAction() {
        if (this.inPolygonGeofences != null && this.inPolygonGeofences.length > 0) {
          this.selectedAction = this.actions.find((x) => x.id === 'link');
        } else if (this.nearPolygonGeofencesThatAreNotPointsSortedByDistance.length > 0) {
          if (
            this.nearPolygonGeofencesThatAreNotPointsSortedByDistance[0].distanceInMeters <=
            this.nearPolygonGeofencesSortedByDistance[0].distanceInMeters
          ) {
            this.selectedAction = this.actions.find((x) => x.id === 'add');
          } else {
            this.selectedAction = this.actions.find((x) => x.id === 'link');
          }
        } else if (this.nearPolygonGeofencesSortedByDistance.length > 0) {
          this.selectedAction = this.actions.find((x) => x.id === 'link');
        } else {
          [this.selectedAction] = this.actions;
        }
      },
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  #app {
    .create-geofence-from-polygon-modal {
      .modal-dialog {
        max-width: 128rem;
        width: calc(100% - 6rem);
        margin-left: auto;
        margin-right: auto;
      }
    }

    .modal-body {
      padding: 0;

      input[type='radio'] {
        margin-right: 1rem;
      }

      .form-container {
        padding: 3.2rem;

        .well {
          margin-bottom: 0;
        }

        .alert {
          margin-bottom: 0;
        }
      }
    }
  }

  .items-list {
    padding-left: 1.6rem;
    margin-bottom: 0;

    &.no-padding {
      padding-left: 0;
    }

    li {
      padding: 0;
      margin: 0 0 0.8rem 0;
      list-style: none;

      &:last-of-type {
        margin-bottom: 0;
      }

      .item {
        margin: 0;
        display: flex;
        flex-direction: row;

        input[type='radio'] {
          margin-top: 0.4rem;
          margin-right: 0.6rem;
        }
      }
    }
  }

  .static-map {
    text-align: center;

    img {
      max-width: 100%;
    }
  }
</style>
